<div class="header-padding">
	<div class="header-container">
		<div class="report-info">
			<h2 class="report-title">Blast Performance</h2>
			<p class="report-subtitle">
				<span class="subtitle-span">Fragmentation Table View</span> - visualizes 
			</p>
		</div>
		<div class="export-btn">
			<button mat-raised-button color="primary" class="export-pdf-btn" (click)="addFinesGoalValues()"
				[disabled]="!siteId || tableLoading"> <mat-icon class="svg-icon" svgIcon="addIcon"></mat-icon>Add
				Goals</button>
		</div>
	</div>
</div>
<div class="excel-style-container">

	<ng-container *ngIf="!siteId">
		<div class="content-container empty-image">
			<mat-icon svgIcon="empty-icon" class="empty-icon"></mat-icon>
			<div class="no-data"><h4>Please select site prior to add fine goals.</h4></div>
		</div>
	</ng-container>

	<div class="table-content" *ngIf="!loading && siteId;">
		<table mat-table [dataSource]="dataSource" class="data mat-elevation-z1 excel-table">
			
				<!-- Project Column -->
				<ng-container matColumnDef="project">
					<th mat-header-cell *matHeaderCellDef> Project </th>
					<td mat-cell *matCellDef="let element"> {{element.project}} </td>
				</ng-container>

				<!-- Fine Column -->
				<ng-container matColumnDef="fines">
					<th mat-header-cell *matHeaderCellDef> Fines </th>
					<td mat-cell *matCellDef="let element"> {{element.fines}} </td>
				</ng-container>

				<!-- Fines Goal Column -->
				<ng-container matColumnDef="finesGoal">
					<th mat-header-cell *matHeaderCellDef> Fines Goal (%)</th>
					<td mat-cell *matCellDef="let element">
						<input matInput [(ngModel)]="element.finesGoal" type="number" min="0"
							(change)="onInputChange()">
					</td>
				</ng-container>

				<!-- Oversize Column -->
				<ng-container matColumnDef="oversize">
					<th mat-header-cell *matHeaderCellDef> Oversize (%)</th>
					<td mat-cell *matCellDef="let element"> {{element.oversize}} </td>
				</ng-container>

				<!-- Oversize Goal Column -->
				<ng-container matColumnDef="oversizeGoal">
					<th mat-header-cell *matHeaderCellDef> Oversize Goal (%)</th>
					<td mat-cell *matCellDef="let element">
						<input matInput [(ngModel)]="element.oversizeGoal" type="number" min="0"
							(change)="onInputChange()">
					</td>
				</ng-container>

				<!-- Muckpile Column -->
				<ng-container matColumnDef="muckpileTonnage">
					<th mat-header-cell *matHeaderCellDef> Muckpile (%)</th>
					<td mat-cell *matCellDef="let element"> {{element.muckpileTonnage}} </td>
				</ng-container>

				<!-- Muckpile Goal Column -->
				<ng-container matColumnDef="muckpileTonnageGoal">
					<th mat-header-cell *matHeaderCellDef> Muckpile Goal (%)</th>
					<td mat-cell *matCellDef="let element">
						<input matInput [(ngModel)]="element.muckpileTonnageGoal" type="number" min="0"
							(change)="onInputChange()">
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

		</table>

		<mat-paginator pageSize="30" [pageSizeOptions]="[30, 40]" hidePageSize="true">
		</mat-paginator>

		<ng-container *ngIf="loading || tableLoading">
			<div class="loading-logo">
				<mat-spinner></mat-spinner>
			</div>
		</ng-container>
	</div>